import * as types from "./mutation-types";

export default {
    [types.SLACK_SET_CHANNELS]: (state, channels = []) => {
        state.channels = [...channels]
    },
    [types.SLACK_SET_IS_SIGNED_IN]: (state, is_signed_in) => {
        state.is_signed_in = is_signed_in
    },
    [types.SLACK_SET_USER]: (state, user) => {
        if (!state.users_object[user.id]) {
            state.users = [...state.users, {...user }]
            state.users_object = {...state.users_object, [user.id]: {...user } }
        }
    },
    [types.SLACK_SET_USERS]: (state, users = []) => {
        state.users_object = {}
        users.forEach(user => {
            state.users_object[user.id] = {...user }
        })
        state.users = [...Object.values(state.users_object)]
    },
}